import { cn } from "@/lib/utils";

export default function SkeletonRow({ className }: { className?: string }) {
  return <div className={cn("py-4 flex-1 rounded-full skeleton", className)} />;
}
